import '../pages/LandingPage.css';
import Img_vector from '../assets/Vector.svg';
import vector_plus from '../assets/Vector_plus.svg';
import { Link, useNavigate } from 'react-router-dom';
import Layout from './Layout';

function LandingPage({ username, onSignOut }) {
    const cards = [
        {
            id: 1,
            title: "Primary Packaging",
            description: "Flexible packaging, Labels, Metal cans, glass bottles, PET bottles etc"
        },
        {
            id: 2,
            title: "Secondary Packaging",
            description: "Shipping boxes, Corrugated boxes, Monocartons, Trays, etc."
        },
        {
            id: 3,
            title: "Electricals",
            description: "Stamped, cut, bent/rolled, or otherwise formed flat metal (panels, trays, metal body, covers)"
        },
        {
            id: 4,
            title: "Pipes, Tubes & Fittings",
            description: "Tubular conveyance and all connection accessories (pipes, elbows, tees, flanges, seals, hose)"
        },
        {
            id: 5,
            title: "Enclosures",
            description: "Plastic - Injection Molded parts"
        },
        {
            id: 6,
            title: "Electromechanical",
            description: "Compressors, Motors etc."
        },
        {
            id: 7,
            title: "Machined Parts",
            description: "Plenum PlateRC, Chamber Body, Diffuser Plenum, Lower Body"
        },
        {
            id: 8,
            title: "Tyre Component",
            description: "Molds, Bead Wire, Car Cords etc."
        },
        {
            id: 9,
            title: "Insulation",
            description: "Mineral Wool, Polystyrene Foam, Urethane and other foam products"
        }
    ];
    const navigate = useNavigate();

    const handleCardClick = (card) => {
        navigate("/Category", { state: card });
    };

    return (
        <Layout username={username} onSignOut={onSignOut}>
            <div className="container-fluid Home">
                <div className='row'>
                    <div className="SummaryBreadCrumb border-b-[1px] border-[#CFCFCF] gap-2">
                        <Link to="/">
                            <span className="SummaryBreadCrumbInside cursor-pointer hover:text-black">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M8.33464 17.4538V12.4538H11.668V17.4538H15.8346V10.7871H18.3346L10.0013 3.28711L1.66797 10.7871H4.16797V17.4538H8.33464Z" />
                                </svg>
                                <span className="SummaryText">Home</span>
                            </span>
                        </Link>
                        <span>/</span>
                        <span className="HomeText">Should Cost Modeling</span>
                    </div>
                </div>
                <div className='row mt-10 mb-4'>
                    <div className='col-1'></div>
                    <div className='w-[63%]'>
                        <div className='LandingSearchBar'>
                            <div className='LandingSearchBar-search'>
                                <img src={Img_vector} alt="Img_vector" className="Img_vector" />
                                <div className='LandingSearchBar-searchinput'>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="w-11/12"
                                    // value={searchTerm}
                                    // onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-[20%] relative group">
                        <Link to="/should-cost">
                            <span className="LandingButton justify-center cursor-pointer hover:bg-[#7500C0] relative">
                                <span className="SummaryButtonText">Should Cost Calculator</span>
                            </span>
                        </Link>
                        <div className="absolute left-1/2 -translate-x-1/2 mt-2 hidden group-hover:flex flex-col items-center z-10">
                            <div className="w-2 h-2 bg-white rotate-45 mb-[-4px] border-l border-t border-gray-300"></div>
                            <div className="bg-white border border-gray-300 px-3 py-2 rounded shadow-md">
                                <span className="buttonTooltip">
                                    Start with a new category and add your own documents and Prompts
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='col-1'></div>
                </div>
                <div className='row'>
                    <div className='col-1'></div>
                    <div className='col-10 border-b-[1px] border-[#CFCFCF]'></div>
                    <div className='col-1'></div>
                </div>
                <div className='row'>
                    <div className='col-1'></div>
                    <div className='col-10 flex'>
                        <div className='py-3 text-[#000000] font-semibold text-[14px]'>
                            <span>Use a Pre-configured expert</span>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-1'></div>
                    <div className="col-10">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
                            {cards.map((card) => (
                                <div
                                    key={card.id}
                                    className="group LandingCard transition-all duration-300 hover:bg-[#E6DCFF] overflow-hidden self-start cursor-pointer"
                                >
                                    <div className='LandingCardBody'>
                                        <h3 className="LandingCardTitle" onClick={() => handleCardClick(card)}>{card.title}</h3>
                                        <div className="max-h-0 group-hover:max-h-40 group-hover:opacity-100 transition-all duration-500 ease-in-out overflow-hidden">
                                            <p className="LandingCardDescription pt-2">
                                                {card.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='col-1'></div>
                </div>
            </div>
        </Layout>
    )
}
export default LandingPage;